import createNode from './createNode'

export default text => {
	if (navigator.clipboard) {
		// clipboard api 复制
		navigator.clipboard.writeText(text)
	} else {
		const $el = createNode('textarea', {
			style: 'position:fixed;top:10px;clip:rect(0 0 0 0)'
		})

		// 赋值
		$el.value = text
		// 选中
		$el.select()
		// 复制
		document.execCommand('copy', true)
		// 移除输入框
		document.body.removeChild($el)
	}
}